import en from 'commonAssets/i18n/en';

en.signature = `Agent Full Name`
en.confirmation_screen_additional.body = `<div id="warranty-calculation"></div>`

en.confirmation_page.title = `The Extended Coverage & Annual Sunroof Drain Cleaning form has been submitted successfully`

en.confirmation_page.claim_details.title = `Details`
en.confirmation_page.claim_details.body = `INFORMATION`
en.confirmation_page.claim_details.footer = ``
en.confirmation_this_is_a_copy = `THIS IS A COPY OF THE CLAIM FORM`

export default { en };
